import { buildInstantProducts, } from './headless-instant-products.js';
/**
 * Defines the `InstantProducts` controller for the purpose of server-side rendering.
 * @group Definers
 *
 * @returns The `InstantProducts` controller definition.
 */
export function defineInstantProducts(props = { options: {} }) {
    return {
        listing: true,
        search: true,
        standalone: true,
        build: (engine) => buildInstantProducts(engine, props),
    };
}
